import React from 'react';
import { ClickOutlined, WarningOutlined } from '@easyv/react-icons';
import {
  concatUrl,
  formatNumber,
  getAssetsPrefix,
  isNil,
  jumpToModelOptimizerPage,
  parseFileSize,
} from '@/utils';
import { Grid } from '@easyv/react-components';
import { AssetItem, ModelInfo } from '@/type';
import { requestFile } from '@easytwin/runtime';

const Row = Grid.Row;
const Col = Grid.Col;

export interface ModelInfoWarningPanelProps {
  assetItem: AssetItem<'model'>;
  data: ModelInfo;
}
export function ModelWarningPanel(props: ModelInfoWarningPanelProps) {
  const { data, assetItem } = props;

  const textMap: {
    label: string;
    data: React.ReactNode;
  }[] = [
    {
      label: '文件大小',
      data: parseFileSize(data.fileSize),
    },
    {
      label: '模型尺寸',
      data: `${data?.size?.x?.toFixed(2)} m X ${data?.size?.y?.toFixed(
        2,
      )} m X ${data?.size?.z?.toFixed(2)} m`,
    },
    {
      label: '面数',
      data: formatNumber(data.triangleCount),
    },
    {
      label: '材质数量',
      data: formatNumber(data.materialCount),
    },
  ];

  const canBeOptimized = data?.warnings.find((b) => typeof b !== 'string' && b.canOptimize);

  return (
    <div className='text-sm flex flex-col gap-y-2'>
      <div className='text-white text-sm flex items-center justify-between'>
        模型信息
        {canBeOptimized && !(window as any).__EASYTWIN_CONFIGS__.local && (
          <span
            className='text-primary inline-flex items-center gap-x-[2px] ms-2 cursor-pointer'
            onClick={async () => {
              if (!assetItem.url) {
                console.error('模型上不存在url');
                return;
              }
              const file = await requestFile(
                concatUrl(getAssetsPrefix(), assetItem.url),
                undefined,
                'blob',
              );
              jumpToModelOptimizerPage(assetItem.name, file);
            }}
          >
            <ClickOutlined />
            <span>去优化</span>
          </span>
        )}
      </div>
      <div className='text-warning text-xs py-2 flex items-center'>
        <WarningOutlined size={16} className='pr-2' />
        <div>
          {canBeOptimized
            ? '模型可优化，建议优化后导入'
            : '该模型存在参数错误，可忽略警告继续使用，但可能存在问题，建议修复后使用'}
        </div>
      </div>
      <Row className='text-xs'>
        <Col span={6}>警告信息</Col>
        <Col span={18}>
          <div className='max-h-20 overflow-scroll no-scroll-container bg-bg292930 text-baseText px-2 py-[6px] border rounded-md border-FFFFFF0F flex flex-col leading-5'>
            {data?.warnings.map((a, index) => (
              <div key={index}>{typeof a === 'string' ? a : a.message}</div>
            ))}
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={6} className='text-xs'>
          模型名称
        </Col>
        <Col span={18} className='text-xs text-baseText'>
          {assetItem.name}
        </Col>
      </Row>

      <div className='flex flex-col gap-y-2'>
        {textMap.map((a) => {
          return (
            <Row key={a.label}>
              <Col span={6} className='text-xs'>
                {a.label}
              </Col>
              <Col span={18} className='text-xs text-baseText'>
                {a.data}
              </Col>
            </Row>
          );
        })}
      </div>
    </div>
  );
}
